import * as customIcons from './custom';

const icons = customIcons;

export default icons;
